import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=56244a96"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/compare/compare.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./_id.vue?vue&type=style&index=1&id=56244a96&prod&lang=scss"
import style2 from "./_id.vue?vue&type=style&index=2&id=56244a96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonImg: require('/root/workspace/web-company_Yo6Q/components/common/commonImg.vue').default,CompareDetails: require('/root/workspace/web-company_Yo6Q/components/compare/compareDetails.vue').default,DealerTisk: require('/root/workspace/web-company_Yo6Q/components/dealer/head/dealerTisk.vue').default,DealerModule: require('/root/workspace/web-company_Yo6Q/components/dealer/head/dealerModule.vue').default})
